import k from '../constants/k'
import { w } from '../state/globals'
import player from '../components/player'
import arrow from '../components/arrow'
import inventory from '../components/inventory'
import { mouse } from '../components/mouse'
import book from '../components/book'
import { inCauldron } from '../state/globals'

k.loadSound('meow', 'sounds/meow.ogg')

k.loadSprite('cauldron', 'sprites/cauldron.png')
k.loadSprite('progress', 'sprites/progress.png', {
  sliceY: 4,
  anims: {
    0: 0,
    1: 1,
    2: 2,
    3: 3
  }
})
k.loadSprite('room-background', 'sprites/backgrounds/room.png')

export default () => {
  k.add([k.sprite('room-background'), k.area(), 'background'])
  player()
  const { cursor } = mouse()
  inventory(cursor)
  book(cursor)

  // cauldron
  const cauldron = k.add([
    k.sprite('cauldron'),
    k.pos(w / 2, 95),
    k.anchor('center'),
    k.area(),
    k.scale(),
    'cauldron'
  ])

  const progress = cauldron.add([
    k.sprite('progress'),
    k.pos(-22 / 2, -5),
    'progress'
  ])
  progress.play(inCauldron.length.toString())

  arrow('right', 'garden', cursor)

  const catArea = k.add([
    k.area(),
    k.rect(16, 16),
    k.pos(w - 50, 32),
    k.opacity(0)
  ])

  catArea.onClick(() => k.play('meow'))
  catArea.onHover(() => cursor.play('pointer'))
  catArea.onHoverEnd(() => cursor.play('default'))
}
